import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`;

const SkeletonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: normal;
  }
`;

const SkeletonRowNoBreak = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`;

const SkeletonBox = styled.div`
  background-color: #e9e8ec;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;

const TopBar = styled(SkeletonBox)`
  max-width: 358px;
  width: 100%;
  height: 24px;
`;

const NavItem = styled(SkeletonBox)`
  max-width: 76px;
  width: 100%;
  height: 24px;
  height: ${({ height }) => (height ? height : "24px")};
`;

const TopRightBar = styled(SkeletonBox)`
  max-width: 132px;
  width: 100%;
  height: 24px;
`;

const MainLeft = styled(SkeletonBox)`
  flex: 2;
  height: 226px;
  @media (max-width: 1000px) {
    flex: auto;
  }
`;

const RightTop = styled(SkeletonBox)`
  height: 153px;
  border-radius: 8px;
`;

const RightBottom = styled(SkeletonBox)`
  height: 57px;
  border-radius: 8px;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

const BottomSection = styled.div`
  display: flex;
  gap: 16px;

  @media (max-width: 768px) {
    overflow-x: hidden;
    width: calc(100% + 16px);
    position: relative;

    & > * {
      flex: 0 0 calc((100% - 48px) / 2);
      max-width: none;
    }

    &::after {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 32px;
      pointer-events: none;
    }
  }
`;

const EqualColumnBlock = styled(SkeletonBox)`
  height: 424px;
  flex: 1;

  @media (max-width: 768px) {
    flex: 0 0 264px;
  }
`;

const SkeletonTopSection = () => (
  <SkeletonWrapper>
    <SkeletonRowNoBreak>
      <TopBar />
      <TopRightBar />
    </SkeletonRowNoBreak>
    <SkeletonRow>
      <MainLeft />
      <RightColumn>
        <RightTop />
        <RightBottom />
      </RightColumn>
    </SkeletonRow>
    <div>
      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        <NavItem />
        <NavItem />
      </div>
      <NavItem height="16px" />
    </div>
    <BottomSection>
      <EqualColumnBlock />
      <EqualColumnBlock />
      <EqualColumnBlock />
      <EqualColumnBlock />
    </BottomSection>
    <NavItem height="16px" />
    <BottomSection>
      <EqualColumnBlock />
      <EqualColumnBlock />
      <EqualColumnBlock />
      <EqualColumnBlock />
    </BottomSection>
  </SkeletonWrapper>
);

export default SkeletonTopSection;
